import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export const useMotoristaNavegacao = () => {
  const history = useHistory();

  const handleNovo = useCallback(() => {
    history.push('/pages/motoristas/cadastro');
  }, [history]);

  const handleVisualizar = useCallback(
    (motorista) => {
      history.push(`/pages/motoristas/detalhes/${motorista.Id || motorista.id}`);
    },
    [history],
  );

  return {
    handleNovo,
    handleVisualizar,
  };
};
